<template>
 <v-layout justify-center>
    <v-flex xs12 sm6>
   
 <v-card  dense>
     <v-toolbar dense color='primary' dark>
       Create User
      </v-toolbar>
      <v-container fluid  >
  <v-form v-model="valid">
      <v-text-field
        class="style-input"
        label="Email"
        v-validate="'required'"
        data-vv-name="email"
        type="email"
        :error-messages="errors.collect('email')"
        v-model="form.email"
        required
      >
      </v-text-field>
         <div class="d-flex">
      <v-text-field
        class="style-input mr-2"
        label="First Name"
        :error-messages="errors.collect('firstName')"        
        v-model="form.firstName"
      ></v-text-field> 
      <v-text-field
          class="style-input mr-2"
          label="Last Name"
          v-model="form.lastName"
       
        ></v-text-field>           
    </div>
     <div class="d-flex">
      <v-text-field
        class="style-input mr-2"
        label="User Name"
        :error-messages="errors.collect('username')"        
        v-model="form.username"
      ></v-text-field> 
      <v-text-field
          class="style-input mr-2"
          label="Mobile"
          v-model="form.mobile"
        type="mobile"
        ></v-text-field>           
    </div>
        <v-layout class="justify-center">
    <div class="form-btn2">
      <v-btn  @click="submit" small color="primary">Create</v-btn>
      <v-btn  @click="clear" small color="primary">Clear</v-btn>
    </div>
    </v-layout>

  </v-form>
         </v-container>
  </v-card>
  </v-flex>
  </v-layout>
</template>
<style>
</style>
<script>
//import UserModel from '../../api/service/UserService.js';

import UserModel from '@/api/service/UserService';

export default {
  $_veeValidate: {
    validator: 'new'
  },  
  data: () => ({
    saveCard: true,
    valid: true,
    authTypes: [
        {"id":"TB","name":"Tibura"},
        {"id":"LD","name":"Ldap"},
        {"id":"GO","name":"Gmail"},
        {"id":"36","name":"Office 365"}
    ],
    form: {
      email: '',
      password:'',  
      emailerror:false,
      passworderror:false
    }

  }),
  mounted () {
    this.$validator.localize('en', this.dictionary);
  },
  
  methods: {
    validate() {

        if(this.form.email ==='') { this.valid=false; this.emailerror=false}
    
       
    },
    submit () {
      this.$validator.validateAll();
      this.validate();
      console.log(this.valid)
      if (this.valid) {      
      var navigate = this.$router;
      var stores = this.$store;
     // console.log(localStorage)  
      UserModel.create(this.form)
        .then(response => {
            navigate.replace('/user/index')
            
        }).catch(error => {
            console.log(error);
            console.log('I am getting error')
            //alert(error);
        }); 
      }
      },
    clear () {
      this.form = {};
      this.$validator.reset();
    },
    validatePortal() {
      UserModel.validate(this.form)
    }
  }
};
</script>

<style  scoped>
  .style-input {
    padding:0px;
    margin:0px;
    width:100%;
  }
  .style-input1 {
    background-color:yellow;
  }
</style>
